module.exports = __webpack_public_path__ + "img/player.e3183af3.jpeg";